import { giphyDarkestGrey } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import { Button, TextInput } from 'ui'
import { brightnessFromColor } from 'utils'
import ColorPickerComponent from '../../../color-picker'

export const Panel = styled.div`
    align-items: stretch;
    display: flex;
`

export const ColorPicker = styled(ColorPickerComponent)`
    flex-shrink: 0;
    width: 176px;
`

export const Colors = styled.div`
    margin-right: 30px;
    width: 100%;
`

export const HexInput = styled(TextInput)`
    grid-column-end: 4;
    grid-column-start: 1;
`

export const Swatches = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 10px;
`

export const SwatchButton = styled(Button)<{ color: string }>`
    min-width: 0;
    padding: 0;

    ${({ color }) => {
        const brightness = brightnessFromColor(color)
        const backgroundBrightess = brightnessFromColor(giphyDarkestGrey)
        const isDark = brightness <= backgroundBrightess

        return css`
            box-shadow: ${isDark ? 'inset 0 0 0 1px rgba(255, 255, 255, 0.3)' : 'none'};
        `
    }}

    svg {
        filter: drop-shadow(0 0 12px #000);
        width: 60%;

        path {
            fill: #fff;
        }
    }
`
